import 'twin.macro';
import React, { useMemo } from 'react';
import FacebookFeedPreview from './channels/facebook/FeedPreview';
import InstagramFeedPreview from './channels/instagram/FeedPreview';
import LinkedInFeedPreview from './channels/linkedin/FeedPreview';
import InstagramStoryPreview from './channels/instagram/StoryPreview';
import FacebookReelsPreview from './channels/facebook/ReelsPreview';
import InstagramReelsPreview from './channels/instagram/ReelsPreview';
import TikTokPreview from './channels/tiktok/Preview';
import useAdEditorContext from 'hooks/context/ad-editor-context';
import AdEditorToolbar from './Toolbar';
import { AdChannel, AdPlacement } from 'types/adTypes';
import VideoGenProvider from 'context/VideoGenContext';
import ChannelRestrictionsSummary from './ChannelRestrictionsSummary';
import NonSupportedPreview from './NonSupportedPreview';

export const AdEditorPreview: React.FC = () => {
  const { currentVariant, previewChannel, setActiveTab } = useAdEditorContext();

  const previewer = useMemo(() => {
    if (!currentVariant || !previewChannel) {
      return <FacebookFeedPreview />;
    }

    const previewMap: Record<string, React.ReactElement> = {
      [`${AdPlacement.FEED}-${AdChannel.FACEBOOK}`]: <FacebookFeedPreview />,
      [`${AdPlacement.FEED}-${AdChannel.INSTAGRAM}`]: <InstagramFeedPreview />,
      [`${AdPlacement.FEED}-${AdChannel.LINKEDIN}`]: <LinkedInFeedPreview />,

      [`${AdPlacement.STORIES}-${AdChannel.FACEBOOK}`]: (
        <InstagramStoryPreview />
      ),
      [`${AdPlacement.STORIES}-${AdChannel.INSTAGRAM}`]: (
        <InstagramStoryPreview />
      ),

      [`${AdPlacement.REELS}-${AdChannel.FACEBOOK}`]: <FacebookReelsPreview />,
      [`${AdPlacement.REELS}-${AdChannel.INSTAGRAM}`]: (
        <InstagramReelsPreview />
      ),
      [`${AdPlacement.REELS}-${AdChannel.TIKTOK}`]: <TikTokPreview />,
    };

    const key = `${currentVariant.placement}-${previewChannel}`;
    const previewComponent = previewMap[key];

    return (
      previewComponent || (
        <NonSupportedPreview
          channel={previewChannel}
          variant={currentVariant}
        />
      )
    );
  }, [currentVariant?.placement, previewChannel]);

  return (
    <div tw="relative">
      <VideoGenProvider>
        {previewer}
        <div
          id="toolbar"
          tw="mb-2 max-w-fit sm:(mt-0 absolute top-0 -right-16 left-auto) z-50 fixed bg-white bottom-0 left-0"
        >
          <AdEditorToolbar setActiveTab={setActiveTab} />
        </div>
        {currentVariant && (
          <div tw="mt-4">
            <ChannelRestrictionsSummary variant={currentVariant} />
          </div>
        )}
      </VideoGenProvider>
    </div>
  );
};

export default AdEditorPreview;
